import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { authInterceptorProviders } from '../helper/auth.interceptor';
import { networkLatencyInterceptorProvider } from '../helper/network-latency.interceptor';
import { fakeBackendProvider } from '../helper/fake-bakend';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    authInterceptorProviders,
    networkLatencyInterceptorProvider, // Registered AFTER auth — purely observational
    fakeBackendProvider]
};
